import { useEffect } from 'react';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

import { usePathname } from 'src/routes/hooks';

import { Logo } from 'src/components/logo';
import { Scrollbar } from 'src/components/scrollbar';

import { Nav, NavUl } from '../components';
import { NavList } from './nav-mobile-list';
import { PurchaseButton } from '../../../components/purchase-button';
import { Button, Typography } from '@mui/material';
import { useLocale } from 'src/locales';
import { ENV } from 'src/global-config';

// ----------------------------------------------------------------------

export function NavMobile({ data, open, onClose, slots, sx }) {
  const { t } = useLocale();
  const pathname = usePathname();
  const env = ENV;

  useEffect(() => {
    if (open) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: [
            {
              display: 'flex',
              flexDirection: 'column',
              width: 'var(--layout-nav-mobile-width)',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
          ],
        },
      }}
    >
      {slots?.topArea ?? (
        <Box
          sx={{
            pt: 3,
            pb: 2,
            pl: 2.5,
            display: 'flex',
          }}
        >
          <Logo />
        </Box>
      )}

      <Scrollbar fillContent>
        <Nav
          sx={{
            pb: 3,
            display: 'flex',
            flex: '1 1 auto',
            flexDirection: 'column',
          }}
        >
          <NavUl>
            {data.map((list) => (
              <NavList key={list.title} data={list} />
            ))}
            <Typography
              variant="body2"
              sx={{
                px: 2.5,
                mt: 3,
                bgcolor: 'primary.main',
                p: 1,
                borderRadius: 1,
                textAlign: 'center',
                color: 'primary.contrastText',
                cursor: 'pointer',
                textDecoration: 'none',
                width: '75%',
                mx: 'auto',
              }}
              component="a"
              href={
                env === 'qa'
                  ? 'https://corporate-qa.shahen-sa.com/'
                  : 'https://corporate.shahen-sa.com/'
              }
              target="_blank"
            >
              {t('Login')}
            </Typography>
          </NavUl>
        </Nav>
      </Scrollbar>
    </Drawer>
  );
}
